module.exports = __webpack_public_path__ + "img/polygon.1087d3d6.svg";